import { render } from "./bcc.vue?vue&type=template&id=004266ce&scoped=true"
import script from "./bcc.vue?vue&type=script&lang=js"
export * from "./bcc.vue?vue&type=script&lang=js"

import "./bcc.vue?vue&type=style&index=0&id=004266ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004266ce"]])

export default __exports__